import { Button, Card, Space, Form, Input } from "antd";
import React, { useEffect, useState } from "react";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import useApi from "../../../hooks/useApi";
import TableComponent from "../../common/TableComponent";
import { EditOutlined, MailOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

function QuotationTable() {
  const columns = [
    {
      title: "Quotation Number",
      dataIndex: "quotation_number",
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Shipment Date",
      dataIndex: "shipment_date",
    },
    {
      title: "Created By",
      dataIndex: "created_by",
    },
    {
      title: "Updated By",
      dataIndex: "updated_by",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <>
          <Space>
            <Button size="small" onClick={() => editRecord(record)}>
              <EditOutlined />
            </Button>
          </Space>
        </>
      ),
    },
  ];

  const [responseData, getRequest] = useApi(
    `/quotation?pageNumber=${1}`,
    null,
    API_METHODS.GET
  );

  const [tableData, setTableData] = useState();

  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [searchVisible, setSearchVisible] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    const pagination =
      responseData.pagination !== BLANK_VALUE ? responseData.pagination : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [responseData]);

  const editRecord = (record) => {
    navigate("/portal/quotation/add", {
      state: record,
    });
  };
  const onPaginationChange = (page) => {
    const values = form.getFieldsValue();
    let url = `/quotation?pageNumber=${page.current}`;

    if (values.quotation_number) {
      url += `&quotation_number=${encodeURIComponent(values.quotation_number)}`;
    }

    getRequest(null, API_METHODS.GET, url);
    setCurrentPage(page.current);
  };

  const handleSearch = () => {
    const values = form.getFieldsValue();
    setCurrentPage(1);
    let url = `/quotation?pageNumber=1`;

    if (values.quotation_number) {
      url += `&quotation_number=${encodeURIComponent(values.quotation_number)}`;
    }

    getRequest(null, API_METHODS.GET, url);
  };

  const handleReset = () => {
    form.resetFields();
    setCurrentPage(1);
    getRequest(null, API_METHODS.GET, `/quotation?pageNumber=1`);
  };

  return (
    <Card
      title="Quotations"
      extra={
        <>
          <Button
            onClick={() => setSearchVisible(!searchVisible)}
            style={{ marginRight: 8 }}
          >
            {searchVisible ? "Hide Search" : "Search"}
          </Button>
          <Button
            type="primary"
            onClick={() => {
              navigate("/portal/quotation/add");
            }}
          >
            Add Quotation
          </Button>
        </>
      }
    >
      {searchVisible && (
        <div
          style={{
            padding: "16px",
            background: "#f5f5f5",
            marginBottom: "16px",
            borderRadius: "6px",
          }}
        >
          <Form form={form} layout="inline">
            <Form.Item name="quotation_number" label="Quotation Number">
              <Input
                placeholder="Search by quotation number"
                style={{ width: 250 }}
              />
            </Form.Item>
            <Form.Item>
              <Button type="primary" onClick={handleSearch}>
                Search
              </Button>
              <Button onClick={handleReset} style={{ marginLeft: 8 }}>
                Reset
              </Button>
            </Form.Item>
          </Form>
        </div>
      )}

      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={responseData.isLoading}
        onPaginationChange={onPaginationChange}
        total={totalRecords}
        current={currentPage}
      />
    </Card>
  );
}

export default QuotationTable;
